import { Logger, uaTool, videoTool } from '../util';
import SimpleDefer from './simple-defer';
var AutoPlayPolicy = /** @class */ (function () {
    function AutoPlayPolicy(videoElement, extra) {
        this.logger = new Logger(extra.instanceId, 'AutoPlayPolicy');
        this.videoElement = videoElement;
    }
    /**
     * 触发自动播放的原理就是调用了play以后马上调用pause，这里会分成两种情况：
     * 1. 如果video.readyState为0（https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLMediaElement/readyState），这里可以
     * 捕获到如下错误，捕获到错误以后触发完成。
     * chrome: The play() request was interrupted by a call to pause()
     * safari/ios: The operation was aborted
     *
     * 2. 如果video.readyState不为0（可能已经设置src或者已经有数据），直接触发完成。
     */
    AutoPlayPolicy.prototype.userTrigger = function () {
        var _this = this;
        this.triggerDefer = new SimpleDefer();
        this.logger.log('userTrigger(), start');
        var catchTimeoutId;
        // video调用一次play和pause，通常情况会catch住一个video抛出来的interrupt异常，如果被自动播放阻止，则为另一个异常
        var catchHandler = function (e) {
            if (catchTimeoutId > 0) {
                clearTimeout(catchTimeoutId);
                catchTimeoutId = 0;
            }
            _this.logger.log('userTrigger(), catch: ', e.name, e.message);
            if (videoTool.isAutoPlayBlockedMessage(e.message)) {
                _this.triggerDefer.reject(e);
            }
            else {
                _this.logger.log('userTrigger() over, catched.');
                _this.triggerDefer.resolve();
            }
        };
        var playPromise = this.videoElement.play();
        this.videoElement.pause();
        if (this.videoElement.readyState === 0) {
            if (playPromise) {
                playPromise.catch(catchHandler);
            }
            // 某些浏览器环境video.play没有返回promise或者play后马上pause不会有catch，这种情况用超时来判断
            catchTimeoutId = window.setTimeout(function () {
                _this.logger.log('userTrigger() over, timeout.');
                _this.triggerDefer.resolve();
            }, 300);
        }
        else {
            this.logger.log('userTrigger() over, sync.');
            var delayTime = (uaTool.browser.safari && !uaTool.mobile) ? 400 : 0;
            // 同步触发的话，play马上pause，那么这两个事件是非常接近的。可能会导致外部来不及处理，所以延迟一下。
            // 但这里调试遇到safari需要点两次播放按钮的问题，具体如下：
            // 1. setTimeout的delay为0时，safari点播放按钮，状态为loadStart,canplay,playing，此时画面不动，需要再点一次
            // 2. setTimeout的delay为400ms（实验值）时，safari点播放按钮，状态为loadStart,canplay,playing，可正常起播
            // 3. 我们把这个setTimeout改成Promise.resolve，发现safari点播放按钮有时候可以成功播放，有时候无法成功播放，
            // 状态均为 loadStart,canplay,playing,pause,playing
            // 4. 去掉这个延迟，即不用setTimeout或Promise，也可能出现点一下播放按钮可播放，或者点两下才可播的情况，
            // 状态均为 loadStart,canplay,playing,pause,playing
            // 所以这里猜测safari浏览器自动播放被阻止后调用play, pause（autoplay-policy内的逻辑），再调用play（外部调用恢复播放）存在异步
            // 调用bug，浏览器兼容性暂无法解决，用上述2的方法延迟处理
            window.setTimeout(function () {
                _this.triggerDefer.resolve();
            }, delayTime);
        }
        return this.triggerDefer.promise;
    };
    AutoPlayPolicy.prototype.destroy = function () {
        this.videoElement = null;
    };
    return AutoPlayPolicy;
}());
export default AutoPlayPolicy;
